import axios from "axios";
import { JOB_PACKAGES_URL } from "../utils";

export const addJobPackage = async (body: any) => {
  return axios.post(JOB_PACKAGES_URL, body);
};
